import { CLIENT_PROFILE_MATCH, CLIENT_SUBSCRIPTIONS_MATCH } from "config/client"
import { BATCH_PAYMENT_PAY_MATCH } from "config/payment"
import {
  PAYMENT_SCHEDULE_VIEW_MODAL_MATCH,
  PAYMENT_SCHEDULE_SIGN_MODAL_MATCH,
  PAYMENT_SCHEDULE_PROMISE_MODAL_MATCH,
} from "config/payment_schedule"
import { ISSUE_CREATE_MODAL_MATCH } from "config/issue"

export const AUTHENTICATION_POLLING_INTERVAL = 3000
export const AUTHENTICATION_POLLING_TIMEOUT = 60000

export const SMART_ID_ERRORS = [
  "GDPR_RESTRICTED",
  "LOGIN_RESTRICTED_BY_CLIENT_WHITE_LIST",
  "USER_REFUSED",
  "USER_REFUSED_DISPLAYTEXTANDPIN",
  "USER_REFUSED_VC_CHOICE",
  "USER_REFUSED_CONFIRMATIONMESSAGE",
  "USER_REFUSED_CONFIRMATIONMESSAGE_WITH_VC_CHOICE",
  "USER_REFUSED_CERT_CHOICE",
  "WRONG_VC",
  "TIMEOUT",
]

export const MOBILE_ID_ERRORS = [
  "GDPR_RESTRICTED",
  "LOGIN_RESTRICTED_BY_CLIENT_WHITE_LIST",
  "NOT_MID_CLIENT",
  "DELIVERY_ERROR",
  "USER_CANCELLED",
  "SIGNATURE_HASH_MISMATCH",
  "SIM_ERROR",
  "PHONE_ABSENT",
  "TIMEOUT",
]

export const ID_CARD_ERRORS = [
  "GDPR_RESTRICTED",
  "LOGIN_RESTRICTED_BY_CLIENT_WHITE_LIST",
  "ERR_WEBEID_ACTION_TIMEOUT",
  "ERR_WEBEID_USER_TIMEOUT",
  "ERR_WEBEID_VERSION_MISMATCH",
  "ERR_WEBEID_VERSION_INVALID",
  "ERR_WEBEID_EXTENSION_UNAVAILABLE",
  "ERR_WEBEID_NATIVE_UNAVAILABLE",
  "ERR_WEBEID_UNKNOWN_ERROR",
  "ERR_WEBEID_CONTEXT_INSECURE",
  "ERR_WEBEID_USER_CANCELLED",
  "ERR_WEBEID_NATIVE_INVALID_ARGUMENT",
  "ERR_WEBEID_NATIVE_FATAL",
  "ERR_WEBEID_ACTION_PENDING",
  "ERR_WEBEID_MISSING_PARAMETER",
]

export const SMART_ID_PERSONAL_CODE =
  process.env.REACT_APP_SMART_ID_PERSONAL_CODE || ""
export const SMART_ID_SIGN_PERSONAL_CODE =
  process.env.REACT_APP_SMART_ID_SIGN_PERSONAL_CODE || ""

export const MOBILE_ID_PERSONAL_CODE =
  process.env.REACT_APP_MOBILE_ID_PERSONAL_CODE || ""
export const MOBILE_ID_PHONE_NUMBER =
  process.env.REACT_APP_MOBILE_ID_PHONE_NUMBER || ""

export const REDIRECT_LIST = [
  BATCH_PAYMENT_PAY_MATCH,
  CLIENT_PROFILE_MATCH,
  CLIENT_SUBSCRIPTIONS_MATCH,
  ISSUE_CREATE_MODAL_MATCH,
  PAYMENT_SCHEDULE_PROMISE_MODAL_MATCH,
  PAYMENT_SCHEDULE_SIGN_MODAL_MATCH,
  PAYMENT_SCHEDULE_VIEW_MODAL_MATCH,
]
